import React, {useEffect} from "react";
import {EditFormLabelErrorWrapper} from "../../Components/ReactTable/EditRecordForm";
import {getArrayValuesFromOptions} from "../../../utils/maybeAddLabelToOptions";
import _ from "lodash";
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";

export function MarketStoreDropdownField({marketStores, markets, label, form}) {

    const [filteredMarketsOptions, setFilteredMarketsOptions] = React.useState([])
    const [filteredMarketsValues, setFilteredMarketsValues] = React.useState([])

    useEffect(() => {
        const storeId = form.getValues('storeId');

        const options = marketStores.filter(option => option.storeId === storeId)

        const marketValues = getArrayValuesFromOptions(_.map(options, 'marketId'), markets)

        setFilteredMarketsOptions(markets)
        setFilteredMarketsValues(marketValues)
        form.setValue("markets", marketValues)
    }, [])


    return (<EditFormLabelErrorWrapper
        id={'markets'}
        form={form}
        label={label}
        isRequired={false}
        value={filteredMarketsValues}
    >
        <div data-testid={`markets-form-dropdown-component-container`}>
            <SelectDropdown
                id={`edit-markets-dropdown`}
                dataTestId={"edit-markets-dropdown"}
                inputId={'markets'}
                options={filteredMarketsOptions}
                selectValues={_.map(filteredMarketsValues, 'value')}
                isDisabled={true}
                isMulti
                isClearable={true}
            />
        </div>
    </EditFormLabelErrorWrapper>)
}
